import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeComponent } from './welcome/welcome.component';
import { SharedRoutingModule } from './shared-routing.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PreRegistrationComponent } from './pre-registration/pre-registration.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule, MatTooltipModule, MatBadgeModule, MatSnackBarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, DateAdapter, MAT_DATE_FORMATS, MatMenuModule, MatDialogModule } from '@angular/material';

import { HttpClientModule } from '@angular/common/http';
import { DataService } from './services/data.service';
import { UserService } from './services/user.service';
import { AuthComponent } from './auth/auth.component';
import { AuthService } from './services/auth.service';
import { StoreModule } from '@ngrx/store';
import { RegistrationService } from './services/registration.service';
import { PaymentService } from './services/payment.service';
import { AccountRegistrationComponent } from './account-registration/account-registration.component';
import { PreRegistrationGdprComponent } from './pre-registration-gdpr/pre-registration-gdpr.component';
import { PreRegistrationReducer } from './state/pre-registration.reducer';
import { LoginComponent } from './login/login.component';
import { SharedReducer } from './state/shared.reducer';
import { AgencyContractService } from './services/agency-contract.service';
import { ApplicationService } from './services/application.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthResolverService } from './services/auth.resolver.service';
import { LookupService } from './services/lookup.service';
import { CountryResolverService,
         RelationshipTypesResolverService,
         VisaSubClassesResolverService,
        OHSCProvidersResolverService,
        YearsOfEntryResolverService,
        EnglishTestTypesResolverService,
        SchoolSubjectResolverService,
        SchoolsResolverService,
        DurationsResolverService,
        TermsResolverService,
        ParentGuardianResolverService,
        SummaryResolverService,
        SummaryWithDocumentsService} from './services/resolvers.service';
import { HeaderComponent } from './header/header.component';
import { SharedService } from './services/shared.service';
import { PaymentComponent } from './payment/payment.component';
import { WelcomeAgentComponent } from './welcome-agent/welcome-agent.component';
import { AgentLoginComponent } from './agent-login/agent-login.component';
import { AgentSetPasswordComponent } from './agent-set-password/agent-set-password.component';
import { StorageService } from './services/storage.service';
import { FormService } from './services/form.service';
import { AutofocusDirective } from '../directives/auto-focus.directive';
import { ToggleViewPasswordDirective } from '../directives/toggle-view-password.directive';
import { AgentAuthComponent } from './auth/agent-auth/agent-auth.component';
import { AgentAccountRegistrationComponent } from './account-registration/agent-account-registration/agent-account-registration.component';
import { AgentForgotPasswordComponent } from './agent-forgot-password/agent-forgot-password.component';
import { AgentResetPasswordComponent } from './agent-reset-password/agent-reset-password.component';
import { PublicPaymentService } from './services/publicPayment.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { ServerErrorComponent } from './server-error/server-error.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { DebounceClickDirective } from './directive/appDebounceClick';
import { DebounceClickModule } from './directive/appDebounceClick.module';
import { PickDateAdapter, PICK_FORMATS } from '../application/shared/utils/PickDateAdapter';
import { PhoneNumberDirective } from '../directives/phone-number.directive';
import { PassportNumberDirective } from '../directives/passport-number.directive';
import { SafeHtmlPipe } from './safe-html.pipe';
import { RectComponent } from './skeleton-rect/skeleton-rect.component';
import { SkeletonDirective } from '../directives/skeleton.directive';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatBadgeModule,
    MatSnackBarModule,
    HttpClientModule,
    SharedRoutingModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    MatMenuModule,
    MatCheckboxModule,
    DebounceClickModule,
    MatListModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    StoreModule.forFeature('shared', SharedReducer)
  ],
  exports: [
    WelcomeComponent,
    HeaderComponent,
    RecaptchaModule,
    RecaptchaFormsModule,
      PhoneNumberDirective,
      PassportNumberDirective,
      SafeHtmlPipe,
      RectComponent,
      SkeletonDirective
  ],
  declarations: [WelcomeComponent,    
    PageNotFoundComponent,
    PreRegistrationComponent,
    AuthComponent,
    AccountRegistrationComponent,
    PreRegistrationGdprComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    HeaderComponent,
    PaymentComponent,
    ServerErrorComponent,
    WelcomeAgentComponent,
    AgentLoginComponent,
    AgentSetPasswordComponent,
    AutofocusDirective,
    ToggleViewPasswordDirective,
    PhoneNumberDirective,
    PassportNumberDirective,
    AgentAuthComponent,
    AgentAccountRegistrationComponent,
    AgentForgotPasswordComponent,
    AgentResetPasswordComponent,
      SafeHtmlPipe,
      RectComponent,
      SkeletonDirective
    ],
  providers: [ SharedService,
              CountryResolverService,
              RelationshipTypesResolverService,
              VisaSubClassesResolverService,
              OHSCProvidersResolverService,
              EnglishTestTypesResolverService,
              DataService,
              LookupService,
              AuthService,
              FormService,
              StorageService,
              RegistrationService,
              PaymentService,
              ApplicationService,
              YearsOfEntryResolverService,
              SchoolSubjectResolverService,
              SchoolsResolverService,
              DurationsResolverService,
              ParentGuardianResolverService,
              SummaryResolverService,
              SummaryWithDocumentsService,
              TermsResolverService,
              UserService,
              AuthResolverService,
              AgencyContractService,
              PublicPaymentService,
              MatNativeDateModule,
              {provide: DateAdapter, useClass: PickDateAdapter},
              {provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS}
             ]
})
export class SharedModule { }
